export const splitTextIntoSpans = (input: string, spanClassName?: string) => {
  const words = input.split(' ');
  return words.map((word, index) => (
    <>
      <span
        key={index}
        style={{ display: 'inline-block' }}
        className={spanClassName}
      >
        {word}
      </span>{' '}
    </>
  ));
};
